// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `* {
  font-family: "Work Sans", sans-serif;
}

body {
  margin: 0;
  padding: 0;
}

.App {
  min-height: 100vh;
  display: flex;
  flex-direction: column;
}

.App-header {
  background-color: #282c34;
  padding: 15px;
  color: white;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
  display: flex;
  align-items: center;
  justify-content: space-between;
}

.App-header h1 {
  margin: 0;
  margin-left: 10px;
  font-family: 'Dosis', sans-serif;
  font-size: 2.5rem;
  font-weight: 700;
  letter-spacing: 1px;
}

.App-header h2 {
  margin: 0;
  font-family: 'Dosis', sans-serif;
  font-size: 1.5rem;
  font-weight: 700;
  letter-spacing: 1px;
}

.App-logo {
  height: 48px;
  width: auto;
  filter: brightness(0) invert(1);
}

.header-contact {
  display: flex;
  flex-direction: column;
  align-items: flex-end;
  gap: 4px;
  margin-left: auto;
}

.header-contact-name {
  font-size: 0.8rem;
  font-weight: 600;
  color: rgba(255, 255, 255, 0.85);
  white-space: nowrap;
  text-decoration: none;
}

.header-created-by {
  text-decoration: none;
  font-size: 0.7rem;
  font-weight: 600;
  color: rgba(255, 255, 255, 0.372);
  white-space: nowrap;
}

.header-contact-links {
  display: flex;
  gap: 15px;
  padding-top: 2px;
}

.header-contact-link {
  color: rgba(255, 255, 255, 0.7);
  display: flex;
  align-items: center;
  transition: color 0.2s;
}

.header-contact-link:hover {
  color: #ffffff;
}

.App-main {
  flex: 1;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  padding: 40px 20px;
}

.route-form {
  display: flex;
  flex-direction: column;
  gap: 12px;
  width: 100%;
  max-width: 480px;
}

.route-description {
  display: none;
}

.intro {
  width: 100%;
  max-width: 480px;
  margin-bottom: 28px;
}

.intro-title {
  margin: 0 0 10px;
  font-size: 1.4rem;
  font-weight: 700;
  color: #282c34;
}

.intro-body {
  margin: 0 0 12px;
  font-size: 0.95rem;
  color: #444;
  line-height: 1.6;
}

.intro-steps {
  margin: 0;
  padding-left: 20px;
  font-size: 0.9rem;
  color: #555;
  line-height: 1.9;
}

.intro-steps li {
  padding-left: 4px;
}

.route-input {
  width: 100%;
  box-sizing: border-box;
}

/* Native input fields */
input.route-input {
  padding: 12px 16px;
  font-size: 1rem;
  border: 1px solid #ccc;
  border-radius: 8px;
  outline: none;
  transition: border-color 0.2s;
}

input.route-input:focus {
  border-color: #282c34;
}

/* PlaceAutocompleteElement web component container */
div.route-input {
  color-scheme: light;
  --gmp-color-surface: #ffffff;
  --gmp-color-on-surface: #1a1a1a;
  --gmp-color-on-surface-variant: #888888;
  --gmp-color-primary: #282c34;
  --gmp-color-outline: #cccccc;
  --gmp-border-radius-container: 8px;
  --gmp-font-family: "Raleway", sans-serif;
}

div.route-input gmp-place-autocomplete {
  width: 100%;
  color-scheme: light;
}

.field-label {
  display: flex;
  flex-direction: column;
  gap: 4px;
  font-size: 1rem;
  font-weight: 600;
  color: #282c34;
}

.stop-row {
  display: flex;
  align-items: flex-end;
  gap: 8px;
}

.stop-row .field-label {
  flex: 1;
}

.add-stop-btn {
  flex-shrink: 0;
  width: 38px;
  padding: 8px 0;
  font-size: 2rem;
  line-height: 1;
  border: 1px solid #282c34;
  border-radius: 4px;
  background: white;
  color: #282c34;
  cursor: pointer;
  transition: background 0.2s, color 0.2s;
}

.add-stop-btn:hover {
  background: #282c34;
  color: white;
}

.remove-stop-btn {
  flex-shrink: 0;
  width: 38px;
  padding: 11px 0;
  font-size: 1.7rem;
  line-height: 1;
  border: 1px solid #c0392b;
  border-radius: 4px;
  background: white;
  color: #c0392b;
  cursor: pointer;
  transition: background 0.2s, color 0.2s;
}

.remove-stop-btn:hover {
  background: #c0392b;
  color: white;
}

.travel-mode-bar {
  display: flex;
  border: 1px solid #ccc;
  border-radius: 8px;
  overflow: hidden;
}

.travel-mode-btn {
  flex: 1;
  padding: 10px 0;
  font-size: 0.9rem;
  font-weight: 600;
  border: none;
  border-right: 1px solid #ccc;
  background: white;
  color: #555;
  cursor: pointer;
  transition: background 0.2s, color 0.2s;
}

.travel-mode-btn:last-child {
  border-right: none;
}

.travel-mode-btn:hover {
  background: #f0f0f0;
}

.travel-mode-btn.active {
  background: #282c34;
  color: white;
}

.submit-btn {
  padding: 12px;
  font-size: 1rem;
  font-weight: 700;
  background-color: #282c34;
  color: white;
  border: none;
  border-radius: 8px;
  cursor: pointer;
  transition: opacity 0.2s;
}

.submit-btn:hover {
  opacity: 0.85;
}

.route-result {
  display: flex;
  flex-direction: column;
  gap: 8px;
  padding: 14px;
  background: #f7f7f7;
  border: 1px solid #ddd;
  border-radius: 8px;
}

.route-result-label {
  font-size: 0.82rem;
  font-weight: 600;
  color: #282c34;
}

.route-result-row {
  display: flex;
  align-items: center;
  gap: 8px;
}

.route-result-link {
  flex: 1;
  font-size: 0.78rem;
  color: #1a73e8;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  text-decoration: none;
}

.route-result-link:hover {
  text-decoration: underline;
}

.route-result-btn {
  flex-shrink: 0;
  padding: 6px 12px;
  font-size: 0.82rem;
  font-weight: 600;
  font-family: "Raleway", sans-serif;
  border: 1px solid #282c34;
  border-radius: 6px;
  background: white;
  color: #282c34;
  cursor: pointer;
  text-decoration: none;
  transition: background 0.2s, color 0.2s;
}

.route-result-btn:hover {
  background: #282c34;
  color: white;
}

.route-result-open {
  background: #282c34;
  color: white;
}

.route-result-open:hover {
  opacity: 0.85;
  background: #282c34;
}
`, "",{"version":3,"sources":["webpack://./src/App.css"],"names":[],"mappings":"AAAA;EACE,oCAAoC;AACtC;;AAEA;EACE,SAAS;EACT,UAAU;AACZ;;AAEA;EACE,iBAAiB;EACjB,aAAa;EACb,sBAAsB;AACxB;;AAEA;EACE,yBAAyB;EACzB,aAAa;EACb,YAAY;EACZ,wCAAwC;EACxC,aAAa;EACb,mBAAmB;EACnB,8BAA8B;AAChC;;AAEA;EACE,SAAS;EACT,iBAAiB;EACjB,gCAAgC;EAChC,iBAAiB;EACjB,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA;EACE,SAAS;EACT,gCAAgC;EAChC,iBAAiB;EACjB,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA;EACE,YAAY;EACZ,WAAW;EACX,+BAA+B;AACjC;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,qBAAqB;EACrB,QAAQ;EACR,iBAAiB;AACnB;;AAEA;EACE,iBAAiB;EACjB,gBAAgB;EAChB,gCAAgC;EAChC,mBAAmB;EACnB,qBAAqB;AACvB;;AAEA;EACE,qBAAqB;EACrB,iBAAiB;EACjB,gBAAgB;EAChB,iCAAiC;EACjC,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,SAAS;EACT,gBAAgB;AAClB;;AAEA;EACE,+BAA+B;EAC/B,aAAa;EACb,mBAAmB;EACnB,sBAAsB;AACxB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,OAAO;EACP,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,uBAAuB;EACvB,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,SAAS;EACT,WAAW;EACX,gBAAgB;AAClB;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,WAAW;EACX,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA;EACE,gBAAgB;EAChB,iBAAiB;EACjB,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,gBAAgB;EAChB,kBAAkB;EAClB,WAAW;EACX,gBAAgB;AAClB;;AAEA;EACE,SAAS;EACT,kBAAkB;EAClB,iBAAiB;EACjB,WAAW;EACX,gBAAgB;AAClB;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,WAAW;EACX,sBAAsB;AACxB;;AAEA,wBAAwB;AACxB;EACE,kBAAkB;EAClB,eAAe;EACf,sBAAsB;EACtB,kBAAkB;EAClB,aAAa;EACb,6BAA6B;AAC/B;;AAEA;EACE,qBAAqB;AACvB;;AAEA,qDAAqD;AACrD;EACE,mBAAmB;EACnB,4BAA4B;EAC5B,+BAA+B;EAC/B,uCAAuC;EACvC,4BAA4B;EAC5B,4BAA4B;EAC5B,kCAAkC;EAClC,wCAAwC;AAC1C;;AAEA;EACE,WAAW;EACX,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,QAAQ;EACR,eAAe;EACf,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,qBAAqB;EACrB,QAAQ;AACV;;AAEA;EACE,OAAO;AACT;;AAEA;EACE,cAAc;EACd,WAAW;EACX,cAAc;EACd,eAAe;EACf,cAAc;EACd,yBAAyB;EACzB,kBAAkB;EAClB,iBAAiB;EACjB,cAAc;EACd,eAAe;EACf,uCAAuC;AACzC;;AAEA;EACE,mBAAmB;EACnB,YAAY;AACd;;AAEA;EACE,cAAc;EACd,WAAW;EACX,eAAe;EACf,iBAAiB;EACjB,cAAc;EACd,yBAAyB;EACzB,kBAAkB;EAClB,iBAAiB;EACjB,cAAc;EACd,eAAe;EACf,uCAAuC;AACzC;;AAEA;EACE,mBAAmB;EACnB,YAAY;AACd;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,OAAO;EACP,eAAe;EACf,iBAAiB;EACjB,gBAAgB;EAChB,YAAY;EACZ,4BAA4B;EAC5B,iBAAiB;EACjB,WAAW;EACX,eAAe;EACf,uCAAuC;AACzC;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;EACnB,YAAY;AACd;;AAEA;EACE,aAAa;EACb,eAAe;EACf,gBAAgB;EAChB,yBAAyB;EACzB,YAAY;EACZ,YAAY;EACZ,kBAAkB;EAClB,eAAe;EACf,wBAAwB;AAC1B;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,QAAQ;EACR,aAAa;EACb,mBAAmB;EACnB,sBAAsB;EACtB,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;EAClB,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;AACV;;AAEA;EACE,OAAO;EACP,kBAAkB;EAClB,cAAc;EACd,mBAAmB;EACnB,gBAAgB;EAChB,uBAAuB;EACvB,qBAAqB;AACvB;;AAEA;EACE,0BAA0B;AAC5B;;AAEA;EACE,cAAc;EACd,iBAAiB;EACjB,kBAAkB;EAClB,gBAAgB;EAChB,kCAAkC;EAClC,yBAAyB;EACzB,kBAAkB;EAClB,iBAAiB;EACjB,cAAc;EACd,eAAe;EACf,qBAAqB;EACrB,uCAAuC;AACzC;;AAEA;EACE,mBAAmB;EACnB,YAAY;AACd;;AAEA;EACE,mBAAmB;EACnB,YAAY;AACd;;AAEA;EACE,aAAa;EACb,mBAAmB;AACrB","sourcesContent":["* {\n  font-family: \"Work Sans\", sans-serif;\n}\n\nbody {\n  margin: 0;\n  padding: 0;\n}\n\n.App {\n  min-height: 100vh;\n  display: flex;\n  flex-direction: column;\n}\n\n.App-header {\n  background-color: #282c34;\n  padding: 15px;\n  color: white;\n  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n}\n\n.App-header h1 {\n  margin: 0;\n  margin-left: 10px;\n  font-family: 'Dosis', sans-serif;\n  font-size: 2.5rem;\n  font-weight: 700;\n  letter-spacing: 1px;\n}\n\n.App-header h2 {\n  margin: 0;\n  font-family: 'Dosis', sans-serif;\n  font-size: 1.5rem;\n  font-weight: 700;\n  letter-spacing: 1px;\n}\n\n.App-logo {\n  height: 48px;\n  width: auto;\n  filter: brightness(0) invert(1);\n}\n\n.header-contact {\n  display: flex;\n  flex-direction: column;\n  align-items: flex-end;\n  gap: 4px;\n  margin-left: auto;\n}\n\n.header-contact-name {\n  font-size: 0.8rem;\n  font-weight: 600;\n  color: rgba(255, 255, 255, 0.85);\n  white-space: nowrap;\n  text-decoration: none;\n}\n\n.header-created-by {\n  text-decoration: none;\n  font-size: 0.7rem;\n  font-weight: 600;\n  color: rgba(255, 255, 255, 0.372);\n  white-space: nowrap;\n}\n\n.header-contact-links {\n  display: flex;\n  gap: 15px;\n  padding-top: 2px;\n}\n\n.header-contact-link {\n  color: rgba(255, 255, 255, 0.7);\n  display: flex;\n  align-items: center;\n  transition: color 0.2s;\n}\n\n.header-contact-link:hover {\n  color: #ffffff;\n}\n\n.App-main {\n  flex: 1;\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  justify-content: center;\n  padding: 40px 20px;\n}\n\n.route-form {\n  display: flex;\n  flex-direction: column;\n  gap: 12px;\n  width: 100%;\n  max-width: 480px;\n}\n\n.route-description {\n  display: none;\n}\n\n.intro {\n  width: 100%;\n  max-width: 480px;\n  margin-bottom: 28px;\n}\n\n.intro-title {\n  margin: 0 0 10px;\n  font-size: 1.4rem;\n  font-weight: 700;\n  color: #282c34;\n}\n\n.intro-body {\n  margin: 0 0 12px;\n  font-size: 0.95rem;\n  color: #444;\n  line-height: 1.6;\n}\n\n.intro-steps {\n  margin: 0;\n  padding-left: 20px;\n  font-size: 0.9rem;\n  color: #555;\n  line-height: 1.9;\n}\n\n.intro-steps li {\n  padding-left: 4px;\n}\n\n.route-input {\n  width: 100%;\n  box-sizing: border-box;\n}\n\n/* Native input fields */\ninput.route-input {\n  padding: 12px 16px;\n  font-size: 1rem;\n  border: 1px solid #ccc;\n  border-radius: 8px;\n  outline: none;\n  transition: border-color 0.2s;\n}\n\ninput.route-input:focus {\n  border-color: #282c34;\n}\n\n/* PlaceAutocompleteElement web component container */\ndiv.route-input {\n  color-scheme: light;\n  --gmp-color-surface: #ffffff;\n  --gmp-color-on-surface: #1a1a1a;\n  --gmp-color-on-surface-variant: #888888;\n  --gmp-color-primary: #282c34;\n  --gmp-color-outline: #cccccc;\n  --gmp-border-radius-container: 8px;\n  --gmp-font-family: \"Raleway\", sans-serif;\n}\n\ndiv.route-input gmp-place-autocomplete {\n  width: 100%;\n  color-scheme: light;\n}\n\n.field-label {\n  display: flex;\n  flex-direction: column;\n  gap: 4px;\n  font-size: 1rem;\n  font-weight: 600;\n  color: #282c34;\n}\n\n.stop-row {\n  display: flex;\n  align-items: flex-end;\n  gap: 8px;\n}\n\n.stop-row .field-label {\n  flex: 1;\n}\n\n.add-stop-btn {\n  flex-shrink: 0;\n  width: 38px;\n  padding: 8px 0;\n  font-size: 2rem;\n  line-height: 1;\n  border: 1px solid #282c34;\n  border-radius: 4px;\n  background: white;\n  color: #282c34;\n  cursor: pointer;\n  transition: background 0.2s, color 0.2s;\n}\n\n.add-stop-btn:hover {\n  background: #282c34;\n  color: white;\n}\n\n.remove-stop-btn {\n  flex-shrink: 0;\n  width: 38px;\n  padding: 11px 0;\n  font-size: 1.7rem;\n  line-height: 1;\n  border: 1px solid #c0392b;\n  border-radius: 4px;\n  background: white;\n  color: #c0392b;\n  cursor: pointer;\n  transition: background 0.2s, color 0.2s;\n}\n\n.remove-stop-btn:hover {\n  background: #c0392b;\n  color: white;\n}\n\n.travel-mode-bar {\n  display: flex;\n  border: 1px solid #ccc;\n  border-radius: 8px;\n  overflow: hidden;\n}\n\n.travel-mode-btn {\n  flex: 1;\n  padding: 10px 0;\n  font-size: 0.9rem;\n  font-weight: 600;\n  border: none;\n  border-right: 1px solid #ccc;\n  background: white;\n  color: #555;\n  cursor: pointer;\n  transition: background 0.2s, color 0.2s;\n}\n\n.travel-mode-btn:last-child {\n  border-right: none;\n}\n\n.travel-mode-btn:hover {\n  background: #f0f0f0;\n}\n\n.travel-mode-btn.active {\n  background: #282c34;\n  color: white;\n}\n\n.submit-btn {\n  padding: 12px;\n  font-size: 1rem;\n  font-weight: 700;\n  background-color: #282c34;\n  color: white;\n  border: none;\n  border-radius: 8px;\n  cursor: pointer;\n  transition: opacity 0.2s;\n}\n\n.submit-btn:hover {\n  opacity: 0.85;\n}\n\n.route-result {\n  display: flex;\n  flex-direction: column;\n  gap: 8px;\n  padding: 14px;\n  background: #f7f7f7;\n  border: 1px solid #ddd;\n  border-radius: 8px;\n}\n\n.route-result-label {\n  font-size: 0.82rem;\n  font-weight: 600;\n  color: #282c34;\n}\n\n.route-result-row {\n  display: flex;\n  align-items: center;\n  gap: 8px;\n}\n\n.route-result-link {\n  flex: 1;\n  font-size: 0.78rem;\n  color: #1a73e8;\n  white-space: nowrap;\n  overflow: hidden;\n  text-overflow: ellipsis;\n  text-decoration: none;\n}\n\n.route-result-link:hover {\n  text-decoration: underline;\n}\n\n.route-result-btn {\n  flex-shrink: 0;\n  padding: 6px 12px;\n  font-size: 0.82rem;\n  font-weight: 600;\n  font-family: \"Raleway\", sans-serif;\n  border: 1px solid #282c34;\n  border-radius: 6px;\n  background: white;\n  color: #282c34;\n  cursor: pointer;\n  text-decoration: none;\n  transition: background 0.2s, color 0.2s;\n}\n\n.route-result-btn:hover {\n  background: #282c34;\n  color: white;\n}\n\n.route-result-open {\n  background: #282c34;\n  color: white;\n}\n\n.route-result-open:hover {\n  opacity: 0.85;\n  background: #282c34;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
